import React from "react";

import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Port } from "../../../../../../../../models/port";
import { Status } from "../../../../../../../../util/enums";
import Input from "../../../../../../../../components/Form/Input";
import SkeletonComponent from "../../../../../../../../components/Generic/Skeleton";

interface Props {
  isOnViewMode?: boolean;
  port?: Port;
  isFetching?: boolean;
}

const General = (props: Props) => {
  const { isFetching = false, isOnViewMode = true, port } = props;
  const { t: translate } = useTranslation();

  return (
    <Grid container direction="row" alignItems="flex-start" spacing={2}>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="city"
            label={translate("city")}
            disabled={isOnViewMode}
            placeholder={translate("city")}
            value={port?.city}
          />
        </SkeletonComponent>
      </Grid>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="site"
            label={translate("site")}
            disabled={isOnViewMode}
            placeholder={translate("site")}
            value={port?.site}
          />
        </SkeletonComponent>
      </Grid>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="siteCode"
            label={translate("siteCode")}
            disabled={isOnViewMode}
            placeholder={translate("siteCode")}
            value={port?.siteCode}
          />
        </SkeletonComponent>
      </Grid>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="country"
            label={translate("country")}
            disabled={isOnViewMode}
            placeholder={translate("country")}
            value={port?.country?.name}
          />
        </SkeletonComponent>
      </Grid>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="locationName"
            label={translate("locationName")}
            disabled={isOnViewMode}
            placeholder={translate("locationName")}
            value={port?.locationName}
          />
        </SkeletonComponent>
      </Grid>

      <Grid item xs={12}>
        <Typography
          color="#475467"
          fontFamily="manrope"
          fontSize="16px"
          fontWeight={600}
          paddingTop="20px"
        >
          {translate("status")}
        </Typography>
      </Grid>
      <Grid item md={6} lg={6}>
        <SkeletonComponent isLoading={isFetching}>
          <Input
            name="portStatus"
            label={translate("portStatus")}
            disabled={isOnViewMode}
            placeholder={translate("portStatus")}
            value={port?.companyPorts?.length ? Status.ACTIVE : Status.INACTIVE}
          />
        </SkeletonComponent>
      </Grid>
    </Grid>
  );
};

export default General;
